module.exports = __webpack_public_path__ + "img/arrow-black.5bb9837c.svg";